/*
 * @Description: Icon font Icon components
 * @Author: Jack Deng
 * @Date: 2021-03-17 11:42:27
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-18 14:57:07
 * @FilePath: /unifyxp-v2-store-portal/src/tools/icon.ts
 */

import { createFromIconfontCN } from '@ant-design/icons';
import { ICON_HOST_URL } from '@/src/tools/config';

export const Icon = createFromIconfontCN({
  scriptUrl: ICON_HOST_URL,
});
